export const CURRENT_FILE = 'CURRENT_FILE';

export const setCurrentFile = (currentFile) => ({
  type: CURRENT_FILE,
  payload: { currentFile }
});